module.exports = "/_next/static/images/7824808f20b7af5cf226827c14c7bf00-nubanker-ds@1x.jpg";